import hrVuetify from 'vuetify/es5/locale/hr'

const messages = {
  // These are the default vuetify translations
  ...hrVuetify,
  // Here write your custom transalations or override the default vuetify ones!! example:
  // dataTable: {
  //     itemsPerPageText: 'Redaka po mojoj stranici'
  // },
  language: 'Jezik',
  currency: 'Valuta',
  all: 'Sve',
  actions: 'Akcije',
  more: 'Više',
  save: 'Spremi',
  item: 'Artikl | Artikli',
  receipt: 'Račun | Računi',
  offer: 'Ponuda | Ponude',
  order: 'Narudžba',
  yes: 'Da',
  no: 'Ne',
  active: 'Aktivan',
  continue: 'Nastavi',
  taxName: 'PDV',
  reset: 'Resetiraj',
  confirm: 'Potvrdi',
  languages: {
    en: 'Engleski',
    hr: 'Hrvatski'
  },
  themes: {
    dark: 'Tamna',
    light: 'Svjetla'
  },
  appLanguageTxt: 'Jezik aplikacije',
  theme: 'Tema',
  price: 'Cijena',
  writeInButtonLabel: 'Slobodan unos artikla ili usluge',
  registerSuccessMsg: 'Uspješno ste registrirali novi račun. Molim potvrdite svoj email!',

  passwordReset: {
    infoMessage: 'Unesite vašu e-mail adresu da bi ste dobili link za promjenu zaporke.',
    resetBtn: 'Pošalji e-mail'
  },

  formDetails: {
    firstName: 'Ime',
    lastName: 'Prezime',
    password: 'Lozinka',
    confirmPassword: 'Potvrdite lozinku',
    termsAgree: 'Slažem se s uvjetima korištenja',
    terms: 'Uvjeti korištenja',
    name: 'Naziv',
    itemName: 'Naziv artikla ili usluge',
    address: 'Adresa',
    city: 'Grad',
    zipCode: 'Poštanski broj',
    country: 'Država',
    oib: 'Oib',
    requiredField: 'Obavezno polje',
    numGreater: 'Value has to be greater than {target}',
    passwordMatchRule: 'Lozinke moraju biti iste',
    oibValid: 'Unesite valjan OIB',
    oibDuplicate: 'OIB već unesen, molim unesite jedinstven OIB.',
    emailValid: 'Unesite valjanu e-mail adresu',
    numberValid: 'Unesite valjan broj',
    usernameValid: 'Unesite valjano korisničko ime',
    logIn: 'Prijava',
    register: 'Registriraj se',
    logOut: 'Odjava',
    registerText: 'Registracija',
    forgotPassword: 'Zaboravili ste lozinku?',
    phone: 'Telefon',
    mobile: 'Mobitel',
    additionalInfo: 'Dodatne informacije',
    associateCode: 'Šifra klijenta',
    leaveFormTitle: 'Da li ste sigurni da želite prekinuti akciju?',
    leaveFormText: 'Neke promjene možda neće biti spremljenje.',
    leave: 'Da',
    stay: 'Odustani',
    downloadReport: 'Preuzmi izvještaj',
    associateType: 'Tip klijenta',
    associateBuyer: 'Kupac',
    associateSupplier: 'Dobavljač',
    firstLast: 'Ime i prezime',
    issueReceipt: 'Račun/Ponuda',
    newArticle: 'aaa',
    unit: 'Jedinica',
    baseAmount: 'Osnovica',
    writeInTitle: 'Unos artikla ili usluge',
    supplierType: 'Tip dobavljača',
    supplierCode: 'Šifra dobavljača',
    username: 'Korisničko ime',
    saveAssociate: 'Spremi klijenta',
    changeReceiptType: 'Promijeni oznaku računa'
  },

  companiesTabs: 'Firma',
  companies: {
    titleText: 'Firma',
    addBtn: 'Dodaj firmu',
    types: {
      doo: 'd.o.o',
      jdoo: 'j.d.o.o',
      crafts: 'Obrt',
      pcrafts: 'Paušalni obrt'
    },
    taxType: 'Tip poreza',
    taxTypes: {
      profit: 'Porez na dobit',
      income: 'Porez na dohodak',
      none: 'Bez poreza'
    },
    warehouseType: 'Vrsta skladišta',
    warehouseTypes: {
      basic: 'Obično',
      module: 'Modul'
    },
    defaultIban: 'Glavni IBAN',
    notePOS: 'Napomena POS',
    noteA4: 'Napomena A4',
    receiptLogo: 'Logo računa',
    digitalSignatureImage: 'Slika digitalnog potpisa',
    imageDimensionExceeding: 'Odabrana slika je široka {width} i visoka {height} pixela. Najveća dozvoljena širina je {maxWidth} piksela a visina {maxHeight} piksela.',
    csv: 'Upload CSV-a'
  },

  users: {
    titleText: 'Korisnici',
    addUser: 'Dodaj korisnika',
    searchLabelText: 'Pretraga po korisničkom imenu'
  },

  add: 'Dodaj',

  reports: {
    titleText: 'Izvještaji',
    addUser: 'Generiraj izvještaj'
    // searchLabelText: 'Pretraga po korisničkom imenu'
  },
  usporedbaGodina: {
    title: 'Usporedba po periodima',
    olderYear: 'Starija godina',
    currentYear: 'Trenutna godina',
    loading: 'Učitavanje podataka...',
    totalComparison: 'Usporedba ukupnog prihoda',
    monthlyChart: 'Prihod po mjesecima',
    monthlyTable: 'Tablica po mjesecima',
    month: 'Mj',
    total: 'Ukupno',
    revenue: 'Prihod'
  },
  statistikeProhoda: {
    title: 'Statistike prohoda'
  },
  uploadItems: {
    titleText: 'Uvoz artikala'
  },
  instructions: {
    titleText: 'Upute'
  },
  warehouse: {
    titleText: 'Skladište',
    titleText2: 'Skladište ',
    addItemsText: 'Dodaj artikl na skladište'
  },
  workorder: {
    titleText: 'Radni nalog',
    staff: 'Osoblje',
    fields: 'Dodatna polja'
  },
  discount: {
    titleText: 'Popusti',
    rate: 'Postotni popust',
    amount: 'Apsolutni popust',
    manual: 'Ručni upis'
  },
  declarations: {
    titleText: 'Deklaracije'
  },
  restaurant: {
    menu: 'Meni'
  },
  printerConfig: {
    title: 'Konfiguracija printera',
    installedPrinter: 'Instaliran Printer',
    installedPrinters: 'Instalirani Printeri',
    networkPrinter: 'Mrežni Printer',
    networkPrinters: 'Mrežni Printeri',
    btPrinter: 'Bluetooth Printer',
    btPrinters: 'Bluetooth Printeri',
    addPrinter: 'Dodaj printer',
    editPrinter: 'Uredi printer',
    selectPrinter: 'Odaberi printer',
    cancel: 'Odustani',
    printerName: 'Naziv printera',
    networkPrinterName: 'Naziv printera na mreži',
    ipAddress: 'Mrežna adresa printera',
    font: 'Font',
    wSize: 'Širina slova',
    hSize: 'Visina slova',
    size: 'Veličina slova',
    width: 'Širina (mm)',
    lineLength: 'Broj znakova u redu',
    port: 'Mrežni port'
  },
  posConfig: {
    title: 'Konfiguracija POS-a'
  },
  cardConfig: {
    title: 'Konfiguracija kartica'
  },
  inventura: {
    title: 'Inventure',
    active: 'Aktivna inventura'
  },
  orgUnitConfig: {
    title: 'Konfiguracija ustrojstvenih jedinica'
  },
  communicationConfig: {
    title: 'Komunikacija'
  },
  companyTabs: {
    admin: 'Admin',
    companySettings: 'Isključivanje firme',
    companyAdd: 'Dodjeljivanje firme',
    myCompanis: 'Firma',
    pointsOfSale: 'Prodajna mjesta',
    lager: 'Lista artikala',
    items: 'Artikli',
    categories: 'Kategorije artikala',
    receipts: 'Računi i ponude',
    associates: 'Klijenti',
    suppliers: 'Dobavljači',
    users: 'Korisnici',
    reports: 'Izvještaji',
    posdReport: 'PO - SD obrazac',
    kprReport: 'Knjiga prometa',
    uploadItems: 'Uvoz artikala',
    instructions: 'Upute',
    norm: 'Lista normativa',
    groupageColection: 'Zbirni promet',
    discounts: 'Popusti',
    incomingEinvoices: 'Ulazni e-računi',
    outgoingEinvoices: 'Izlazni e-računi'
  },
  company: {
    admin: 'Admin',
    companySettings: 'Isključivanje firme',
    companyAdd: 'Dodjeljivanje firme',
    companyWarehouseModule: 'Uključivanje skladišta',
    addPointOfSaleBtn: 'Dodaj prodajno mjesto',
    addLagerItemBtn: 'Dodaj artikl',
    addPrinterBtn: 'Dodaj printer',
    addOrgUnitBtn: 'Dodaj ustrojstvenu jedinicu',
    addAssociate: 'Dodaj klijenta',
    addSupplier: 'Dodaj dobavljača',
    addSupplierIntegration: 'Dodaj način komunikacije',
    addIntegration: 'Dodaj integraciju',
    addCategory: 'Dodaj kategoriju',
    associate: 'Klijent',
    suppliers: 'Dobavljači',
    supplier: 'Dobavljač',
    editAssociate: 'Editiraj klijenta',
    editSupplier: 'Editiraj dobavljača',
    addSupplierItems: 'Dodaj artikle za dobavljača',
    supplierItems: 'Dobavljačevi artikli',
    addNormBtn: 'Dodaj normativ',
    addDiscountBtn: 'Dodaj popust'
  },
  pointsOfSaleTabs: {
    admin: 'Admin',
    companySettings: 'Isključivanje firme',
    companyAdd: 'Dodjeljivanje firme',
    companyWarehouseModule: 'Uključivanje skladišta',
    myCompanis: 'Firma',
    pointsOfSale: 'Prodajna mjesta',
    registers: 'Blagajne',
    lager: 'Lista artikala',
    categories: 'Kategorije artikala',
    warehouse: 'Prodajno mjesto',
    priceList: 'Cjenik',
    receipts: 'Računi i ponude',
    associates: 'Klijenti',
    users: 'Korisnici',
    reports: 'Izvještaji',
    uploadItems: 'Uvoz artikala',
    posdReport: 'PO - SD obrazac',
    kprReport: 'Knjiga prometa',
    instructions: 'Upute',
    warehouseItems: 'Stanje zaliha',
    warehouseDocuments: 'Dokumenti',
    primka: 'Unos primke',
    editDeliveryNote: 'Editiranje primke',
    warehouseDocumentsOverview: 'Pregled dokumenata',
    warehouseDocumentsList: 'Lista dokumenata',
    norm: 'Lista normativa',
    groupageColection: 'Zbirni promet',
    discounts: 'Popusti',
    restaurant: 'Restoran',
    menu: 'Meni',
    master: 'Master',
    inventory: 'Inventura',
    workOrderStaff: 'Osoblje',
    workOrderFields: 'Dodatna polja',
    workOrders: 'Radni nalozi'
  },
  pointOfSale: {
    addLagerItemBtn: 'Dodaj artikl',
    addWarehouseItemBtn: 'Dodaj artikl na prodajno mjesto',
    setWarehouseModule: 'Dodaj artikl na cjenik',
    addCategory: 'Dodaj kategoriju',
    addAssociateBtn: 'Dodaj klijenta',
    addRegisterBtn: 'Dodaj blagajnu',
    addPricelistItemBtn: 'Dodaj artikl',
    stock: 'Stanje',
    searchItemsLabel: 'Pretraži artikle',
    cashRegisterNoAddOptionText: 'Niste u mogućnosti dodati niti jednu blagajnu, probajte dodati certifikat na firmu te pokušajte ponovo.',
    issueReceipt: 'Račun/Ponuda',
    newArticle: 'aaa'
  },

  userDataTabs: {
    userData: 'Postavke',
    bill: 'Račun',
    closeBalance: 'Zaključak blagajne'
  },
  cashRegisterTabs: {
    admin: 'Admin',
    companySettings: 'Isključivanje firme',
    companyAdd: 'Dodjeljivanje firme',
    companyWarehouseModule: 'Uključivanje skladišta',
    myCompanis: 'Firma',
    pointsOfSale: 'Prodajna mjesta',
    registers: 'Blagajne',
    lager: 'Lista artikala',
    warehouse: 'Prodajno mjesto',
    priceList: 'Cjenik',
    receipts: 'Računi i ponude',
    reports: 'Izvještaji',
    posdReport: 'PO - SD obrazac',
    kprReport: 'Knjiga prometa',
    instructions: 'Upute',
    norm: 'Lista normativa',
    closeBalanceTitles: 'Zaključci blagajne',
    groupageColection: 'Zbirni promet',
    logout: 'Odjavi se sa blagajne'
  },
  cashRegister: {
    registerTypes: {
      mp: 'Maloprodajna blagajna',
      vp: 'Veleprodajna blagajna',
      all: 'Sve'
    },
    registerLoginTypes: {
      default: 'Prijava korisnikom - klasično',
      selectUser: 'Prijava odabirom korisnika',
      pincode: 'Prijava unosom PIN-a korisnika'
    },
    afterReceiptBehaviours: {
      emptyBasket: 'Isprazni košaricu',
      showCashRegs: 'Prikaži blagajne',
      showAllReceipts: 'Prikaži sve račune'
    },
    noCategoryItems: 'Ne postoje artikli za kategoriju {category} ili nema artikala u odabranoj valuti. Probajte dodati nove artikle u cijenik ili dodati valutu za željeni artikl.',
    noCategories: 'Ne postoje niti jedna kategorija. Probajte dodati jednu.',
    lastReceiptNumber: 'Zadnji broj računa',
    lastOfferNumber: 'Zadnji broj ponude',
    optionsText: 'Opcije blagajne',
    closeBalanceTitle: 'Zaključak blagajne',
    createRegisterReport: 'Kreiraj izvještaj za blagajnu',
    closingBalanceSearch: 'Datum zaključka',
    user: 'Korisnik ',
    otherUserReserved: ' se ulogirao u blagajnu.',
    selectTemplate: 'Izgled blagajne',
    search: 'Pretraži artikle',
    searchDescription: 'Pretraži artikle po nazivu ili po šifri',
    receiptsOverview: 'Pregled računa',
    selectProduct: 'Odaberi proizvod',
    searchByReceiptNumber: 'Pretraga po broju računa'
  },
  lager: {
    itemName: 'Naziv artikla',
    itemTypes: {
      goods: 'Materijalna dobra',
      service: 'Servisi i usluge'
    }
  },
  priceList: {
    dateFromGreater: 'Vrijeme aktivacije veće od vremena trajanja artikla!',
    noPrice: 'Odaberite barem jednu cijenu za artikl'
  },
  receipts: {
    receiptNumber: 'Broj računa',
    offerNumber: 'Broj ponude',
    customer: 'Klijent',
    receiptPrice: 'Iznos računa',
    offerPrice: 'Iznos ponude',
    receiptIssueDate: 'Datum izdavanja',
    receiptDeliveryDate: 'Datum isporuke',
    receiptPaymentDate: 'Datum plaćanja',
    receiptPaymentDue: 'Datum valute',
    retailCustomer: 'Maloprodajni kupac',
    defaultNote: 'Račun po ponudi broj {offer}.',
    defaultVirman: 'Račun po virmanu broj {virman}.',
    receiptPaidStatus: 'Plaćeno',
    status: 'Status računa',
    PAID: 'Plaćeno',
    UNPAID: 'Neplaćeno',
    PROCESSING: 'Procesiranje',
    EMAIL_SENT: 'E-mail poslan',
    OFFER_SENT: 'E-mail poslan',
    WARNING_SENT: 'Opomena poslana',
    OFFER_CREATED: 'Ponuda kreirana',
    VIRMAN_CREATED: 'Virman kreiran',
    UNKNOWN_STATUS: 'Nepoznat status',
    OK: 'bsfdsf',
    DUPLICATE: 'fsdfdsfdsgfsdgsad',
    fiscalizing: 'Fiskaliziraj sve račune',
    REVERSED: 'Storniran',
    UNCOLLECTIBLE: 'Nenaplativo'
  },
  tables: {
    tables: 'Stolovi',
    create: 'Kreiraj novi',
    close: 'Završi',
    select: 'Odaberi stol',
    selected: 'Odabrani stol',
    saveTo: 'Spremi na',
    saveTable: 'Spremi',
    clear: 'Obriši',
    new: 'Nova',
    save_title: 'Spremanje narudžbe',
    save: 'Želite li spremiti trenutnu narudžbu na stol',
    clearOrder: 'Da li želite obrisati narudžbu sa stola',
    delete: 'Želite li obrisati',
    unlockTitle: 'Otključavanje stola',
    unlockMessage: 'je zaključan. Jeste li sigurni da želite otključati stol?',
    unlockMessageOther: 'je zaključan kod drugog korisnika. Jeste li sigurni da želite otključati stol?',
    note: 'Napomena',
    newTable: 'Spremi na novi stol',
    existingTable: 'Prebaci na postojeći stol',
    splitTablesDisclaimer: 'Kliknite na znak ">" za prebacivanje jednog ili na znak ">>" za prebacivanje svih artikala koje želite naplatiti ili prebaciti na drugi stol.',
    splitTable: 'Podijeli stol',
    splitTableAll: 'Prebaci sve',
    transferTableTitle: 'Predaj stol',
    transferTableButton: 'Predaj stol',
    receiptNote: 'Napomena na računu',
    addReceiptNote: 'Dodaj napomenu',
    selectedItems: 'Artikli',
    noteMessage: 'U košarici postoji narudžba koja nije završena.',
    continue: 'Nastavi',
    cancel: 'Odustani',
    deleteOrder: 'Obriši narudžbu',
    addToTable: 'Dodaj na stol',
    cartRecpitulation: 'Rekapitulacija stola',
    floorPlan: 'Tlocrt'
  },
  tooltips: {
    payWithCash: 'Plati račun gotovinom',
    payWithCards: 'Odaberi karticu za bezgotovinsko plaćanje',
    payR1: 'R1 račun, gotovinski, bezgotovinski ili virmanom',
    selectTable: 'Odaberi postojeći stol ili stvori novi',
    newOrder: 'Ukloni trenutni odabir i kreni sa novom narudżbom',
    clearTable: 'Isprazni odabrani stol. Ako je stol označen za brisanje, bit će obrisan iz baze',
    saveTable: 'Sadržaj košarice spremi na odabrani stol',

    searchItems: 'Pretraži artikle po nazivu',
    repReceipt: 'Označi račun kao reprezentaciju',
    receiptsDialog: 'Pretraži sve račune od posljednjeg zaključka blagajne',
    closeBalance: 'Zaključak blagajne',
    splitTable: 'Podijeli račun za posebno plaćanje odabranih artikala',

    wolt: 'Plaćanje putem Wolta',
    bolt: 'Plaćanje putem Bolta',
    glovo: 'Plaćanje putem Glova',

    enableOsk: 'Uključi/isključi ekransku tipkovnicu'
  },
  errors: {
    errorTitle: 'Greška',
    nullReceipt: 'Nema podataka o računu.',
    nullClosingBalance: 'Nema podataka o zaključku blagajne.',
    nullReportReceipts: 'Ne postoje računi u danom vremenu.',
    unknownRegister: 'Ne postoji kasa na kojoj je napravljen račun ili je u krivom statusu.',
    noCashRegisterData: 'Tehnički problem: Blagajna nedostupna.',
    noCorrespondingUser: 'Email ili lozinka nisu ispravni.',
    wrongPassword: 'Email ili lozinka nisu ispravni.',
    tooManyRequests: 'Pristup vašem računu trenutno je blokiran zbog previše pokušaja upisa lozinke. Možete odmah dobiti pristup ako promjenite vašu lozinku ili pokušajte se ulogirati kasnije.',
    simpleSequence: 'Lozinka nije ispravna: Ne smije sadržavati jednostavan brojčani slijed.',
    passwordContains: 'Lozinka nije ispravna: Ne smije sadržavati ime, prezime ili e-mail adresu.',
    shortPassword: 'Lozinka nije ispravna: Mora sadržavati najmanje 8 znakova.',
    isNotSeller: 'Nemate privilegiju prodavača na ovom prodajnom mjestu, te niste u mogućnosti izdavati račune.<br/>Da biste dodali privilegiju prodavača odaberite<br/> Postavke → Korisnici te za korisnika odaberite privilegiju “PRODAVAČ”.',
    notSellerButSuperuser: 'Niste prodavač, Dodaj privilegiju prodavača?',
    invalidDataUpload: 'Nije uspio uvoz artikala. Molimo pokušajte ponovno.',
    invalidCashRegReservation: 'Nije uspjelo zauzeće blagajne. Molimo pokušajte ponovno.',
    noLeadingSpaces: 'Nisu dozvoljeni razmaci na početku naziva.',
    passwordNumbers: 'Lozinka nije ispravna: Mora sadržavati slova i brojeve.',
    noChangesInEntities: 'Niste napravili izmjene.',
    duplicateCompany: 'Firma sa ovim OIB-om vec je registrirana u sustavu',
    duplicateItem: 'Ovaj artikl je već registriran u sustavu',
    itemCodeDuplicate: 'Šifra koju ste unijeli već postoji u sustavu.',
    accountDisabled: 'Administrator je deaktivirao vaš korisnički račun.'
  },
  messages: {
    resetLinkSent: 'Ukoliko je adresa registrairana u sustavu link za reset lozinke je poslan na vašu e-mail adresu.',
    multipleSignIn: 'Ulogirali ste se na drugom uređaju, ova sesija se prekida.'
  },
  addSellerRole: 'Dodaj privilegiju prodavača?',
  addRole: 'Dodaj privilegiju',
  process: 'Obradi',
  cancel: 'Odustani',
  backward: 'Nazad',
  createRegisterReportBtn: 'Kreiraj izvještaj za blagajnu',
  finishPayment: 'Završi',
  paymentMethodText: 'Način plaćanja',
  issueYear: 'Godina izdavanja',
  issueDate: 'Datum izdavanja računa',
  deliveryDate: 'Datum isporuke',
  paymentDueDate: 'Datum dospijeća računa',
  offerDueDate: 'Datum važenja ponude',
  fiscalizeText: 'Fiskaliziraj',
  receiptTypeText: 'Tip računa',
  amountReceivedText: 'Primljeni iznos',
  name: 'Naziv',
  quantity: 'Količina',
  receiptTitle: 'Plaćanje',
  referenceNumber: 'Poziv na broj',
  receiptNumber: 'Broj računa',
  offerNumber: 'Broj ponude',
  change: 'Ostatak',
  total: 'Ukupno',
  totalWithDiscount: 'Ukupno sa popustom',
  note: 'Napomena',
  journalNum: 'Broj temeljnice',
  noItemsSelected: 'Nema odabranih artikala',
  accountDetailsTitle: 'Detalji računa',
  receiptTypes: {
    noCustomerData: 'Bez podataka o kupcu',
    withCustomerData: 'Sa podacima o kupcu',
    offer: 'Ponuda'
  },
  paymentMethods: {
    cash: 'Gotovinski',
    card: 'Kartično',
    transaction: 'Transakcijski',
    virman: 'Virman/Izdatnica',
    representation: 'Reprezentacija',
    cashMethod: 'Gotovinsko',
    cardMethod: 'Bezgotovinsko',
    offer: 'Ponuda'
  },
  receiptLanguages: {
    en: 'Engleski',
    hr: 'Hrvatski'
  },
  notifications: {
    title: 'Obavijesti'
  },
  companySettings: {
    title: 'Isključivanje firme'
  },
  companyAdd: {
    title: 'Dodavanje firme na support'
  },
  companyWarehouseModule: {
    title: 'Uključivanje skladišta'
  },
  workorders: 'Radni nalozi',
  contractNumText: 'Broj ugovora',
  filterLabel: 'Pretraga',
  filterPlaceholderLabel: 'Počnite tipkati za pretragu...',
  searchLabel: 'Pritisnite enter za pretragu',
  filterOib: 'Klijent (OIB)',
  filterReceiptNumber: 'Broj računa',
  showAdditionalFilters: 'Prikaži dodatne filtere',
  hideAdditionalFilters: 'Sakrij dodatne filtere',
  orders: {
    titleText: 'Narudžbe',
    createOrder: 'Kreiraj narudžbu',
    showOrders: 'Pregledaj narudžbe'
  },
  floorPlan: {
    title: 'Tlocrt',
    openFloorPlan: 'Otvori tlocrt restorana',
    settingsDescription: 'Uredite raspored stolova i prostorija u vašem objektu.',
    openEditor: 'Otvori uređivač',
    editMode: 'Edit mod',
    userMode: 'User mod',
    save: 'Spremi',
    loading: 'Učitavam tlocrt...',
    saving: 'Spremam tlocrt...',
    saved: 'Tlocrt uspješno spremljen',
    loadError: 'Greška pri učitavanju tlocrta',
    saveError: 'Greška pri spremanju tlocrta',
    unsavedChanges: 'Nespremljene promjene',
    unsavedChangesMessage: 'Imate nespremljene promjene. Jeste li sigurni da želite zatvoriti?',
    noRooms: 'Nema prostorija',
    createFirstRoom: 'Kreiraj prvu prostoriju',
    room: 'Prostorija',
    roomName: 'Naziv prostorije',
    width: 'Širina',
    height: 'Visina',
    addRoom: 'Dodaj prostoriju',
    editRoom: 'Uredi prostoriju',
    deleteRoom: 'Obriši prostoriju',
    deleteRoomConfirm: 'Jeste li sigurni da želite obrisati prostoriju "{name}"?',
    tools: 'Alati',
    selectMove: 'Odaberi/Pomakni',
    addTable: 'Dodaj stol',
    addWall: 'Dodaj zid',
    addArea: 'Dodaj oznaku',
    delete: 'Obriši',
    duplicate: 'Dupliciraj',
    circle: 'Krug',
    square: 'Kvadrat',
    rectangle: 'Pravokutnik',
    oval: 'Oval',
    corner: 'Kutni',
    cornerAngle: 'Kut',
    topLeft: 'Gore lijevo',
    topRight: 'Gore desno',
    bottomRight: 'Dolje desno',
    bottomLeft: 'Dolje lijevo',
    view: 'Prikaz',
    zoom: 'Zoom',
    resetView: 'Resetiraj prikaz',
    options: 'Opcije',
    showGrid: 'Prikaži mrežu',
    snapToGrid: 'Privuci na mrežu',
    shortcuts: 'Prečaci',
    deleteSelected: 'Obriši odabrano',
    deselect: 'Poništi odabir',
    items: 'Artikli',
    total: 'Ukupno',
    waiting: 'Vrijeme čekanja',
    available: 'Slobodan',
    occupied: 'Zauzet',
    reserved: 'Rezerviran',
    locked: 'Zaključan',
    noSelection: 'Odaberite objekt za prikaz svojstava',
    properties: 'Svojstva',
    position: 'Pozicija',
    size: 'Veličina',
    rotation: 'Rotacija',
    tableProperties: 'Svojstva stola',
    tableName: 'Naziv stola',
    shape: 'Oblik',
    seats: 'Broj sjedala',
    tableColor: 'Boja stola',
    chairColor: 'Boja stolica',
    linkedTable: 'Povezan stol',
    linkTable: 'Poveži stol',
    changeTable: 'Promijeni stol',
    linked: 'Povezano',
    wallProperties: 'Svojstva zida',
    thickness: 'Debljina',
    color: 'Boja',
    areaProperties: 'Svojstva područja',
    label: 'Oznaka',
    fontSize: 'Veličina fonta',
    backgroundColor: 'Boja pozadine',
    transparent: 'Transparentna pozadina',
    opacity: 'Prozirnost',
    table: 'Stol',
    wall: 'Zid',
    area: 'Područje',
    door: 'Vrata',
    doorProperties: 'Svojstva vrata',
    doorSwing: 'Otvaranje vrata',
    doorLeftIn: 'Lijevo prema unutra',
    doorLeftOut: 'Lijevo prema van',
    doorRightIn: 'Desno prema unutra',
    doorRightOut: 'Desno prema van',
    bar: 'Šank',
    barProperties: 'Svojstva šanka',
    barName: 'Naziv šanka',
    semicircle: 'Polukrug',
    semioval: 'Poluoval',
    borderColor: 'Boja obruba',
    linkTableToObject: 'Poveži stol s objektom',
    canvasObject: 'Objekt na tlocrtu',
    searchTables: 'Pretraži stolove',
    availableTables: 'Dostupni stolovi',
    alreadyLinked: 'Već povezan',
    showLinkedTables: 'Prikaži već povezane',
    noTablesFound: 'Nema pronađenih stolova',
    linkingInfo: 'Povezivanjem ovog stola, status i podaci će se automatski prikazivati na tlocrtu.',
    unlinkTable: 'Ukloni poveznicu',
    link: 'Poveži',
    deleteObject: 'Obriši objekt',
    deleteObjectMessage: 'Jeste li sigurni da želite obrisati ovaj objekt?',
    background: 'Pozadina',
    pattern: 'Uzorak',
    chooseColor: 'Odaberi boju',
    patternNone: 'Bez uzorka',
    patternWood: 'Drvo',
    patternParquet: 'Parket',
    patternTile: 'Pločice',
    patternCarpet: 'Tepih',
    patternMarble: 'Mramor',
    patternConcrete: 'Beton',
    textBox: 'Tekst',
    textBoxProperties: 'Svojstva teksta',
    text: 'Tekst',
    fontFamily: 'Font',
    bold: 'Podebljano',
    italic: 'Kurziv',
    underline: 'Podcrtano',
    textAlign: 'Poravnanje',
    alignLeft: 'Lijevo',
    alignCenter: 'Centar',
    alignRight: 'Desno',
    textColor: 'Boja teksta',
    close: 'Zatvori',
    roomsTitle: 'Prostorije',
    userManual: 'Korisnički priručnik',
    backgroundPatterns: 'Uzorci pozadine',
    keyboardShortcuts: 'Tipkovnički prečaci',
    helpSelectMove: 'Odaberite ovaj alat za odabir, pomicanje, mijenjanje veličine i rotaciju objekata na tlocrtu. Kliknite na objekt da ga odaberete, povucite za pomicanje, i koristite ručke za mijenjanje veličine ili rotaciju.',
    helpTable: 'Stolovi predstavljaju mjesta gdje gosti sjede. Svaki stol može biti povezan sa stolom iz baze podataka kako bi pratili narudžbe. Dostupni su različiti oblici stolova:',
    helpTableCircle: 'Okrugli stol - idealan za manje grupe',
    helpTableSquare: 'Kvadratni stol - stabilan oblik za 4 osobe',
    helpTableRectangle: 'Pravokutni stol - dobar za duže grupe',
    helpTableOval: 'Ovalni stol - elegantan oblik za veće grupe',
    helpTableCorner: 'Kutni stol - savršen za kutnine prostora',
    helpBar: 'Šankovi (barovi) predstavljaju šank ili pult gdje gosti mogu sjesti. Baš kao i stolovi, mogu biti povezani sa stolom u bazi podataka za praćenje narudžbi. Dostupni su različiti oblici: pravokutni, polukrug i poluoval.',
    helpWall: 'Zidovi definiraju strukturu prostora. Kliknite na tlocrt da postavite početnu točku, pa kliknite ponovno za završnu točku. Možete prilagoditi debljinu i boju zida u svojstvima.',
    helpArea: 'Područja su koriste za označavanje različitih zona u prostoru (npr. VIP zona, terasa, pušačka zona). Možete im dodati oznake, boje, uzorke i prilagoditi prozirnost.',
    helpDoor: 'Vrata označavaju ulaze i izlaze. Dostupni su različiti smjerovi otvaranja vrata (lijevo/desno, prema unutra/van). Možete prilagoditi veličinu i orijentaciju.',
    helpText: 'Alat za tekst omogućuje dodavanje tekstualnih oznaka na tlocrt. Možete prilagoditi font, veličinu, boju, poravnanje i stil teksta. Korisno za imenovanje zona ili dodavanje napomena.',
    helpRooms: 'Prostorije omogućuju organizaciju tlocrta u različite prostore (npr. glavna sala, terasa, gornji kat). Svaka prostorija ima vlastitu kolekciju objekata i postavki pozadine. Koristite kartice za prebacivanje između prostorija.',
    helpPatterns: 'Uzorci pozadine dodaju vizualnu teksturu tlocrtu. Možete primijeniti uzorke na cijelu prostoriju ili na pojedinačna područja:',
    helpPatternWood: 'Vertikalne drvene daske',
    helpPatternParquet: 'Horizontalni parket s različitim duljinama dasaka',
    helpPatternTile: 'Šahovska ploča pločica',
    helpPatternCarpet: 'Dijagonalni uzorak tepiha',
    helpPatternMarble: 'Mramorni efekt s mrljama',
    helpPatternConcrete: 'Betonska tekstura s mrežom',
    helpKeyboardShortcuts: 'U user modu možete koristiti tipkovničke prečace za brži rad. Prostorije dobivaju prvo slovo svog naziva kao prečac (npr. "Terasa" → T). Stolovi i barovi dobivaju brojeve iz svog naziva - prva 3 broja (npr. "Stol 1" → 1, "Stol 21" → 21, "Stol 311" → 311). Ako stol nema broj u nazivu, automatski dobiva broj počevši od 100. Ako je broj dupliciran, dodaje se prefix X. Na tipkovnici utipkajte broj stola (npr. 1, 21, 100). Na blagajni se prikazuje kombinacija slovo prostorije + broj stola (npr. T1, T21, B100). Pritisnite i držite tipku S duže od 0.6 sekundi da privremeno prikažete sve prečace.',
    propertiesHelp: 'Pomoć za svojstva',
    helpPropPositionSize: 'Pozicija i veličina',
    helpPropPosition: 'X i Y koordinate objekta na tlocrtu. Možete ručno upisati vrijednosti za precizno pozicioniranje.',
    helpPropSize: 'Širina i visina objekta u pikselima. Mijenjajte za prilagodbu veličine objekta.',
    helpPropRotation: 'Kut rotacije objekta u stupnjevima (0-360°). Koristite za rotiranje objekta.',
    helpPropTableProperties: 'Svojstva stola',
    helpPropLinkedTable: 'Povezivanje s stolom iz baze podataka omogućuje praćenje narudžbi i statusa. Kliknite "Poveži stol" za povezivanje.',
    helpPropTableName: 'Naziv stola koji se prikazuje na tlocrtu. Također se koristi za generiranje tipkovničkih prečaca.',
    helpPropTableShape: 'Odaberite oblik stola (krug, kvadrat, pravokutnik, oval, kut). Različiti oblici odgovaraju različitim prostorima.',
    helpPropSeats: 'Broj sjedala oko stola. Vizualno prikazuje broj stolica.',
    helpPropTableColor: 'Boja površine stola.',
    helpPropChairColor: 'Boja stolica oko stola.',
    helpPropBarProperties: 'Svojstva šanka',
    helpPropBarName: 'Naziv šanka koji se prikazuje na tlocrtu. Koristi se za generiranje tipkovničkih prečaca.',
    helpPropBarShape: 'Odaberite oblik šanka (pravokutnik, polukrug, poluoval).',
    helpPropBarColor: 'Glavna boja šanka.',
    helpPropBorderColor: 'Boja obruba/ruba šanka.',
    helpPropWallProperties: 'Svojstva zida',
    helpPropThickness: 'Debljina zida u pikselima.',
    helpPropWallColor: 'Boja zida.',
    helpPropAreaProperties: 'Svojstva područja',
    helpPropAreaLabel: 'Tekstualna oznaka koja se prikazuje na području (npr. "VIP zona", "Terasa").',
    helpPropFontSize: 'Veličina fonta za tekst oznake.',
    helpPropBackgroundColor: 'Boja pozadine područja.',
    helpPropOpacity: 'Prozirnost područja (0-1). Niže vrijednosti čine područje prozirnije.',
    helpPropPattern: 'Odaberite uzorak teksture za područje (drvo, parket, pločice, itd.).',
    helpPropDoorProperties: 'Svojstva vrata',
    helpPropDoorDirection: 'Smjer otvaranja vrata (lijevo/desno, prema unutra/van).',
    helpPropDoorColor: 'Boja vrata.',
    helpPropTextProperties: 'Svojstva teksta',
    helpPropText: 'Sadržaj tekstualne oznake.',
    helpPropFontFamily: 'Font za prikaz teksta.',
    helpPropTextSize: 'Veličina fonta teksta.',
    helpPropTextColor: 'Boja teksta.',
    helpPropTextBackground: 'Boja pozadine teksta. Može biti transparentna.',
    helpPropTextAlign: 'Poravnanje teksta (lijevo, centar, desno).',
    helpPropTextStyle: 'Stilovi teksta: podebljano za naglašavanje, kurziv za detalje, podcrtano za važno.',
    helpPropActions: 'Akcije',
    helpPropDuplicate: 'Stvara kopiju odabranog objekta na istom mjestu. Koristite za brzo dodavanje sličnih objekata.',
    helpPropDelete: 'Briše odabrani objekt s tlocrta. Ova akcija se može poništiti (Ctrl+Z).',
    doorDirection: 'Smjer vrata'
  }

}

export default {
  $vuetify: messages
}
